import { render, staticRenderFns } from "./CalendarMonteMainBeta.vue?vue&type=template&id=643f562c&"
import script from "./CalendarMonteMainBeta.vue?vue&type=script&lang=js&"
export * from "./CalendarMonteMainBeta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports